<template>
    <basic-dialog>
        <v-card>
            <v-card-title class="headline text-h6">How it works?</v-card-title>
            <v-card-text>
                <ul class="pl-4 text-subtitle-2">
                    <li class="mt-1">Sign up and login using Facebook or Google.</li>
                    <li class="mt-1">Earn coins by watching videos, answering surveys & trying out apps.</li>
                    <li class="mt-1">Redeem your Coins for PayPal Cash or other Gift Card options.</li>
                </ul>
            </v-card-text>
        </v-card>
    </basic-dialog>
</template>

<script>
import {
    ref,
    inject,
    provide,
} from "vue";

import BasicDialog from "@/components/Common/Basic-Dialog.vue";

export default {
    name: "HowItWorksDialog",
    components: {
        BasicDialog,
    },
    setup() {
        let openDialog = ref(false);

        openDialog = inject("howItWorksDialog");
        provide("openDialog", openDialog);
    }
}
</script>

<style scoped lang="scss">
.v-card {
    background: none;
    box-shadow: none;
}
</style>